import React from "react";
import { RCCBadge, RCCGrid, RCCIcon } from "react-common-components";
import UserColumn from "src/components/DefaultColumnsList/User";
import List from "src/components/List";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { AuditType, AuditSituation, IListAudits } from "../interface";
import { DivFlexColumn, OverflowSpan } from "../styles";

const ListAudits: React.FC<IListAudits> = ({
	data,
	options,
	filter,
	layout
}) => {
	const { translate, currentLanguage } = useTranslation();

	const colData = (row : any) => (
	  <>
		  <RCCGrid container item alignItems="center">
				<RCCIcon 
					name="calendar"
					size={16}
					color="var(--default-color-font)"
					style={{marginRight: "4px"}}
				/>
				{formatDate(row.adb001Dtinicioplan, currentLanguage)} - { formatDate(row.adb001Dtfimplan, currentLanguage)}
		  </RCCGrid>
	  </>
	);

	const colAudit = (row: any) => (
		<OverflowSpan title={row.fullTitle} style={{ paddingLeft: "0.2rem" }}>
			 <b>{row.fullTitle}</b>
		</OverflowSpan>
	);

	const colResponsable = (row: any) => (
		<>
			<UserColumn 
				name={row.adb001Efa005Nome2}
				image={row.adb001Efa005Imagem2}	
			/>
		</>
	);

	const colSituation = (row: any) => {

		let color: "blue" | "purple" | "red" | "green" | "grey" | "black";
		let text = "";

		switch(row.adb001Situacao){
		case AuditSituation.OPENED:
			text = translate("Aberta");
			color = "purple";
			break;
		case AuditSituation.IN_AUDIT:
			text = translate("Em Auditoria");
			color = "blue";
			break;
		case AuditSituation.FINISHED:
			text = translate("Concluída");
			color = "green";
			break;
		default: 
			color = "green";
			break;
		}

		return (
			<>
				<DivFlexColumn>
					<RCCBadge color={row.adb001Tipo === AuditType.EXTERNAL ? "grey" : "black"} styleInline="padding: 2px 8px; font-size: 0.78rem;">{translate(row.type)}</RCCBadge>
				</DivFlexColumn>
				<DivFlexColumn>	
					<RCCBadge color={color} styleInline="padding: 2px 8px; font-size: 0.78rem;">{text}</RCCBadge>
				</DivFlexColumn>  
				<div style={{ position: "absolute", top: 0, left: 0, width: "4px", height: "100%", background: `var(--${color})`}}/>
			</>
		);
	};

	return (
		<>
			<List 
				data={data}
				filter={filter}
				layout={layout ?? undefined}
				columns={[
					{
						idColumn: "fullTitle",
						nameColumn: translate("Título"),
						xs: 12,
						sm: 3,
						justify: "left",
						cellRenderer: colAudit
					},
					{
						idColumn: "period",
						nameColumn: translate("Período"),
						xs: 12,
						sm: 2,
						justify: "left",
						cellRenderer: colData 
					},
					{
						idColumn: "adb001Ada001Descricao",
						nameColumn: translate("Norma"),	
						xs: 12,
						sm: 2,
						justify: "left",
						truncate: true
					},
					{
						idColumn: "adb001Taa005Descricao",
						nameColumn: translate("Processo"),
						xs: 12,
						sm: 1,
						justify: "left",
						truncate: true,
						hidden: ["sm"]
					},
					{
						idColumn: "adb001Taa001Descricao",
						nameColumn: translate("Setor"),
						xs: 12,
						sm: 1,
						justify: "left",
						hidden: ["sm", "md"],
						truncate: true
					},
					{
						idColumn: "eftba005",
						nameColumn: translate("Responsável"),
						xs: 12,
						md: 2,
						sm: 2,
						justify: "left",
						cellRenderer: colResponsable
					},
					{
						idColumn: "adb001Situacao",
						nameColumn: "",
						xs: 12,
						md: 1,
						sm: 1,
						justify: "left",
						cellRenderer: colSituation
					},
					{
						idColumn: "options",
						nameColumn: " ",
						styleInline: "position: absolute; right: -8px; bottom: 0; width: fit-content !important;",
						hideHeader: true,
						cellRenderer: options
					}
				]}
				styleInline="li.list-component-child { border-top-left-radius: 0; border-bottom-left-radius: 0; }"
				showHeader
			/>
		</> 
	);

};

export default ListAudits;
